import { Article, IMicros } from "@tm/models"
import { Box, BasketAmountField } from "@tm/components"

import { Decimal } from "decimal.js-light"

type Props = Omit<IMicros["basket"]["add-to-basket"], "data"> & {
    article: Article
    division?: number
    onQuantityChange(article: Article, newQuantity: number): void
}

export function QuantityField(props: Props) {
    const { hideQuantityField, article, onQuantityChange, disabled } = props

    const division = props.division || 1

    function handleQuantityChange(amount: number) {
        const rest = new Decimal(amount).modulo(division).toNumber()
        const quantity = rest ? new Decimal(amount).add(division).sub(rest).toNumber() : amount
        onQuantityChange(article, quantity)
    }

    if (hideQuantityField) {
        return null
    }

    return (
        <Box marginRight=".25em">
            <BasketAmountField
                originalQuantity={article.quantity}
                division={division}
                onChangeQuantity={handleQuantityChange}
                loadErpInfos
                disabled={disabled}
            />
        </Box>
    )
}
